export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ja.lyaml"));
at({ "ja": { "public": { "sampleString": "\u30B5\u30F3\u30D7\u30EB\u6587\u5B57\u5217" } } });
};